import NumberFormat from "react-number-format"

export const formatNumber = (number) =>{
    return <NumberFormat 
                value={number===null ? 0 : number}
                thousandSeparator={true}
                displayType="text"
           />
}